module.exports = __webpack_public_path__ + "static/media/icon-thumb-up.d807166d.svg";